import { createSlice } from "@reduxjs/toolkit";
import { getCoachesAvailabilityApi } from "./availabilityApi";

const initialState = {
  availability: [], // coaches availability for selected date
  availabilityLoading: false,
  availabilityError: null,
};

export const availabilitySlice = createSlice({
  name: "availability",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCoachesAvailabilityApi.pending, (state) => {
      state.availabilityLoading = true;
      state.availabilityError = null;
    });
    builder.addCase(getCoachesAvailabilityApi.fulfilled, (state, action) => {
      state.availabilityLoading = false;
      state.availabilityError = null;
      state.availability = action.payload.data || [];
    });
    builder.addCase(getCoachesAvailabilityApi.rejected, (state, action) => {
      state.availabilityLoading = false;
      state.availability = [];
      state.availabilityError =
        action.payload?.message || "Failed to fetch coaches availability";
    });
  },
});

export default availabilitySlice.reducer;
